import { z } from 'zod';
import { MemberDTO } from './members.js';

export const SearchQuery = z.object({
  q: z.string().trim().min(1).max(200).optional(),
  tags: z.string().trim().max(500).optional(),
  industry: z.string().trim().max(200).optional(),
  city: z.string().trim().max(200).optional(),
  hasOffering: z.coerce.boolean().optional(),
  limit: z.coerce.number().int().min(1).max(200).optional(),
});
export type SearchQuery = z.infer<typeof SearchQuery>;

export const SearchResult = z.object({
  member: MemberDTO,
  snippet: z.string().nullable(),
  matchedFields: z.array(z.string()),
});
export type SearchResult = z.infer<typeof SearchResult>;

export const SearchResponse = z.object({
  results: z.array(SearchResult),
  total: z.number(),
});
export type SearchResponse = z.infer<typeof SearchResponse>;
